import { fetchAPI } from "../lib/fetch";

export const invokeDocumentAgentApi = async (
  query: string,
  memory: string,
  docs: [] | string,
  projectname: string
) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/documentagent`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const queryDocumentAgent = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        query: query,
        memory: memory,
        docs: docs,
        projectname: projectname,
      }),
    });

    return queryDocumentAgent;
  } catch (error) {
    // console.log("error from invoke document agent api...", error);
    return null;
  }
};

export const invokeSearchAgentApi = async (query: string, memory: string) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/searchagent`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const querySearchAgent = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        query: query,
        memory: memory,
      }),
    });

    return querySearchAgent;
  } catch (error) {
    // console.log("error from invoke search agent api...", error);
    return null;
  }
};

export const invokeGoogleSearchApi = async (query: string) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/googlesearch`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const googlesearchresp = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        query: query,
      }),
    });

    return googlesearchresp;
  } catch (error) {
    // console.log("error from google search agent api...", error);
    return null;
  }
};

export const invokeDummyAgentApi = async (query: string, memory: string) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/dummyagent`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const dummyagentresp = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        query: query,
        memory: memory,
      }),
    });

    return dummyagentresp;
  } catch (error) {
    // console.log("error from invoke dummy agent api...", error);
    return null;
  }
};

export const invokeImageAgentApi = async (
  query: string,
  cogid: string,
  qk: string,
  projectname: string
) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/imageagent`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const imageagentresp = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        query: query,
        cogid: cogid,
        key: qk,
        projectname: projectname,
      }),
    });

    return imageagentresp;
  } catch (error) {
    // console.log("error from invoke image agent api...", error);
    return null;
  }
};

export const invokeQueryImageAgentApi = async (query: string, images: any) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/documentagent/queryimageagent`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const queryimhresp = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        query: query,
        images: images,
      }),
    });

    return queryimhresp;
  } catch (error) {
    // console.log("error from query image agent api...", error);
    return null;
  }
};

export const invokeTTSAgentApi = async (
  text: string,
  idenid: string,
  title: string,
  projectname: string
) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/ttsagent`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        text: text,
        idenid: idenid,
        key: title,
        projectname: projectname,
      }),
    });

    return true;
  } catch (error) {
    // console.log("error from invoke image agent api...", error);
    return null;
  }
};

export const invokePDFloaderagent = async (key: string, id: string) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/documentagent/pdfloaderagent`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const loaderres = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        key: key,
        identityId: id,
      }),
    });

    // console.log("loader response", loaderres);

    return loaderres;
  } catch (error) {
    // console.log("error from invoke pdf loader agent api...", error);
    return "";
  }
};
